'use strict';

var _ = require('lodash');
var UrdConditionSerializerService = function UrdConditionSerializerService() {
  var URD_CATEGORY = 'User Def Ref Data';
  var URD_OPERAND_DETERMINING_PART = '.urd(';
  var URD_METRIC_NAMES = {
    'Cabin Load Factor': 'LOAD_FACTOR'
  };
  function isUrdCategory(category) {
    return category === URD_CATEGORY;
  }
  function isUrdConditionByOperandValue(operandValue) {
    return _.isString(operandValue) && operandValue.indexOf(URD_OPERAND_DETERMINING_PART) !== -1;
  }
  function getDomainFromField(fieldName) {
    return fieldName.substring(0, fieldName.indexOf('.'));
  }
  function translateMetric(metric) {
    return URD_METRIC_NAMES.hasOwnProperty(metric) ? URD_METRIC_NAMES[metric] : _.snakeCase(metric).toUpperCase();
  }
  function formatMetric(metric, flowType) {
    metric = _.isString(flowType) ? flowType.replace(/FlowType./g, '') + ' ' + metric : metric;
    return translateMetric(metric);
  }
  function serialize(fieldName, operandValue, metric, functionType, flowType) {
    return getDomainFromField(fieldName) + '.urd(\'' + formatMetric(metric, flowType) + '\',\'' + functionType + '\',' + (_.isNull(operandValue) ? operandValue + ')' : '\'' + operandValue + '\')');
  }
  function deserialize(value) {
    var result = value.match(/'([^']*)'/g);
    return {
      functionType: result[1].replace(/'/g, ''),
      leftOperand: result[2] ? result[2].replace(/'/g, '') : ''
    };
  }
  return {
    URD_CATEGORY: URD_CATEGORY,
    isUrdCategory: isUrdCategory,
    isUrdConditionByOperandValue: isUrdConditionByOperandValue,
    serialize: serialize,
    deserialize: deserialize
  };
};
UrdConditionSerializerService.$inject = [];
module.exports = UrdConditionSerializerService;